import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import { useNavigate } from "react-router-dom";

const FlightSegment = ({ segment, searchDetails, resultIndex }) => {
    const navigate = useNavigate();
    console.log("FlightSegment:", segment);
    console.log("Search Details:", searchDetails);
    console.log("Result Index:", resultIndex);
    const depTime = new Date(segment.Origin.DepTime).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
    const arrTime = new Date(segment.Destination.ArrTime).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });

    const handleClick = () => {
        // Navigate to multi-city booking page with state
        navigate(`/booking/${segment.Airline.FlightNumber}`, {
            state: { segment, searchDetails }
        });
    };

    return (
        <Box
            sx={{ mb: 2, cursor: "pointer", p: 2, border: "1px solid #ddd", borderRadius: 2, "&:hover": { bgcolor: "#f5f5f5" } }}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => { if (e.key === 'Enter') handleClick(); }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2">
                        <FlightTakeoffIcon fontSize="small" sx={{ mr: 0.5 }} />
                        {segment.Origin.Airport.CityName} ({segment.Origin.Airport.AirportCode}) - {depTime}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2">
                        <FlightLandIcon fontSize="small" sx={{ mr: 0.5 }} />
                        {segment.Destination.Airport.CityName} ({segment.Destination.Airport.AirportCode}) - {arrTime}
                    </Typography>
                </Grid>
            </Grid>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Airline: {segment.Airline.AirlineName} ({segment.Airline.FlightNumber}) | Baggage: {segment.Baggage}
            </Typography>
        </Box>
    );
};

export default FlightSegment;
